 
import CTNTable from '@ctn/ui/components/ctn-table';
import { type CTNTableRef, type CustomColumnDef } from '@ctn/ui/types/ctn-table';
import { type ForwardedRef, type ReactElement } from 'react';

import { PAGE_SIZE } from '@/constants/table.constants';
import { type ISolicitudDocumentacion } from '@/interfaces/model/don.interface';

type SolicitudesDocumentacionListadoTramiteProps = {
	readonly onPageChange?: (page: number) => void;
	readonly columns: Array<CustomColumnDef<ISolicitudDocumentacion>>;
	readonly isLoading?: boolean;
	readonly data: ISolicitudDocumentacion[];
	readonly totalData: number;
	readonly tableRef?: ForwardedRef<CTNTableRef<ISolicitudDocumentacion>>;
};

const SolicitudesDocumentacionListado = ({
	tableRef,
	columns,
	isLoading = false,
	data,
	totalData,
	onPageChange,
}: SolicitudesDocumentacionListadoTramiteProps): ReactElement => (
	<CTNTable
		ref={tableRef}
		manualPagination
		idData="id"
		loading={isLoading}
		loadingConf={{ spinner: true }}
		columns={columns}
		data={data}
		totalData={totalData}
		manualPageCount={totalData / PAGE_SIZE.OPERACIONES}
		pageSize={PAGE_SIZE.OPERACIONES}
		className="c-pnp-table"
		onPageChange={onPageChange}
	/>
);

export default SolicitudesDocumentacionListado;
